export default Object.freeze({
  PENDING: 'PENDING',
  EXTRACTING: 'EXTRACTING',
  EXTRACTING_FAILED: 'EXTRACTING_FAILED',
  PROCESSING: 'PROCESSING',
  DETECTING_DUPLICATES: 'DETECTING_DUPLICATES',
  TIMED_OUT: 'TIMED_OUT',
  COMPLETE: 'COMPLETE',
  ERROR: 'ERROR',
});
